import { useMemo } from "react";

import TileGrid, { GridLoader } from "../NavigationTile/TileGrid";
import LinkCard from "./LinkCard";
import { type ILinkCard, type TContent } from "./LinkCards.types";

interface Props {
  content: TContent | undefined;
  pathPrefix?: string | Array<string | undefined>;
  loading?: boolean;
  onClicks?: { [key: string]: () => void };
  useSectForPath?: boolean;
}

const LinkCards = ({
  content,
  pathPrefix,
  loading,
  onClicks,
  useSectForPath,
}: Props) => {
  const cards = useMemo(() => {
    let parsedContent: ILinkCard[] = [];
    let preparedContent: ILinkCard[] = [];
    if (onClicks) {
      parsedContent = Object.keys(onClicks).map(key => ({
        name: key,
        desc: "",
        onClick: onClicks[key],
      }));
    }

    if (!content) {
      preparedContent = parsedContent;
    } else {
      const contentArray = Array.isArray(content)
        ? content
        : typeof content.list === "object"
          ? Object.values(content.list)
          : [];

      preparedContent = [
        ...contentArray.map((data: ILinkCard) => ({
          ...data,
          path: useSectForPath
            ? data.sect?.replaceAll("_", "")
            : data.name?.toLowerCase().replaceAll(" ", "-"),
        })),
        ...parsedContent,
      ];
    }

    return preparedContent.filter(card =>
      "permitted" in card ? card.permitted : true,
    );
  }, [content, onClicks, useSectForPath]);

  if (loading) {
    return <GridLoader />;
  }

  return (
    <TileGrid>
      {cards.map((card, i) => (
        <LinkCard key={`card-${i}`} {...card} pathPrefix={pathPrefix} />
      ))}
    </TileGrid>
  );
};

export default LinkCards;
